export interface ComfortState {
  bg: string;
  border: string;
  text: string;
  label: string;
  icon?: 'droplet';
}

export const getComfortState = (temp: number, humidity: number): ComfortState => {
  // 쾌적조건 규칙 구현
  // RH > 85%: 결로 우려 (물방울 블루) -> 조건 1: 최우선 판정 여부
  if (humidity > 85) {
    return {
      bg: 'bg-blue-600/40',
      border: 'border-blue-500/50',
      text: 'text-blue-200',
      label: 'comfort.condensation',
      icon: 'droplet'
    };
  }

  if (temp >= 28) {
    return { bg: 'bg-red-500/40', border: 'border-red-400/50', text: 'text-red-200', label: 'comfort.very_hot' };
  }
  
  if (temp > 25 && temp < 28) {
    if (humidity > 60) return { bg: 'bg-orange-500/40', border: 'border-orange-400/50', text: 'text-orange-200', label: 'comfort.hot_humid' };
    return { bg: 'bg-orange-500/40', border: 'border-orange-400/50', text: 'text-orange-200', label: 'comfort.hot' };
  }

  if (temp >= 18 && temp <= 25) {
    if (humidity > 60) return { bg: 'bg-orange-500/40', border: 'border-orange-400/50', text: 'text-orange-200', label: 'comfort.warm_humid' };
    if (humidity < 40) return { bg: 'bg-yellow-500/40', border: 'border-yellow-400/50', text: 'text-yellow-200', label: 'comfort.warm_dry' };
    return { bg: 'bg-emerald-500/40', border: 'border-emerald-400/50', text: 'text-emerald-200', label: 'comfort.perfect' };
  }

  if (temp >= 15 && temp < 18) {
    if (humidity > 60) return { bg: 'bg-yellow-500/40', border: 'border-yellow-400/50', text: 'text-yellow-200', label: 'comfort.cool_humid' };
    return { bg: 'bg-yellow-500/40', border: 'border-yellow-400/50', text: 'text-yellow-200', label: 'comfort.cool' };
  }

  // T < 15
  return { bg: 'bg-blue-500/40', border: 'border-blue-400/50', text: 'text-blue-200', label: 'comfort.very_cold' };
};

// Temperature comfort scoring
export function scoreTemp(temp: number): number {
  if (temp >= 22 && temp <= 26) return 100;
  if ((temp >= 20 && temp < 22) || (temp > 26 && temp <= 28)) return 70;
  if ((temp >= 18 && temp < 20) || (temp > 28 && temp <= 30)) return 40;
  return 10;
}

// Humidity comfort scoring
export function scoreHumidity(h: number): number {
  if (h >= 40 && h <= 60) return 100;
  if ((h >= 30 && h < 40) || (h > 60 && h <= 70)) return 70;
  if ((h >= 20 && h < 30) || (h > 70 && h <= 80)) return 40;
  return 10;
}

// Score to color: maps sensor score to its display color (hue)
export function scoreToColor(score: number): {
  r: number;
  g: number;
  b: number;
} {
  if (score >= 80) return { r: 52, g: 211, b: 153 }; // emerald
  if (score >= 60) return { r: 34, g: 211, b: 238 }; // cyan
  if (score >= 40) return { r: 251, g: 191, b: 36 }; // amber
  return { r: 248, g: 113, b: 113 }; // red
}
